module.exports = __webpack_public_path__ + "static/media/signup.561d233b.png";